// apps/web/src/lib/delta-format.ts
//
// Delta-arrow + colour utility per CISO-surfaces spec §5.2.
//
// The audit found that several Analytics panels rendered "▼ red" for
// "ransomware claims dropped" because chart code colour-coded by raw
// direction. This utility decouples direction (arrow) from semantic
// (colour) so red/green correctly reflect "good news / bad news"
// regardless of which way the underlying number moved.
//
// Used everywhere a numeric delta is rendered — Dashboard tiles +
// Analytics Decide / Trends / Compare panels.

export type DeltaPolarity = "good-up" | "bad-up" | "neutral";

export interface DeltaFormatArgs {
  value: number;
  valuePolarity: DeltaPolarity;
}

export interface DeltaFormatResult {
  arrow: "▲" | "▼" | "—";
  colour: "red" | "green" | "neutral";
  sign: "+" | "−" | "";
}

export function formatDelta(args: DeltaFormatArgs): DeltaFormatResult {
  const { value, valuePolarity } = args;
  if (value === 0) {
    return { arrow: "—", colour: "neutral", sign: "" };
  }
  const arrow = value > 0 ? "▲" : "▼";
  const sign = value > 0 ? "+" : "−";

  let colour: "red" | "green" | "neutral";
  if (valuePolarity === "neutral") {
    colour = "neutral";
  } else if (valuePolarity === "bad-up") {
    colour = value > 0 ? "red" : "green";
  } else {
    colour = value > 0 ? "green" : "red";
  }
  return { arrow, colour, sign };
}
